import { ServerResponse } from 'http';
import Router from 'next/router';

export const redirect = (url: string, res?: ServerResponse, code = 302): void => {
  if (res) {
    res.writeHead(code, {
      Location: url,
    });
    res.end();
  } else {
    Router.push(url).then(() => window.scrollTo(0, 0));
  }
};

export const replaceRoute = (url: string): void => {
  Router.push(url).then(() => window.scrollTo(0, 0));
};
